import { FONT } from "@/styles";
import { Box, Center, Text } from "@chakra-ui/react";
import { type PaginationProps } from "./paginationType.props";

export const Pagination = ({
    showPage = true,
    totalPages,
    currentPage,
    nextPage,
    prevPage,
    colorMode = "white",
}: PaginationProps) => {
    return (
        <Center gap="24px">
            {/* 이전 버튼 */}
            <Center
                onClick={prevPage}
                role="button"
                sx={{
                    "& svg .arrow-line, & svg .arrow-head": {
                        transition: "transform 0.3s ease",
                        transform: "translateX(0)",
                    },
                    "&:hover svg .arrow-line, &:hover svg .arrow-head": {
                        transform: "translateX(-10px)",
                    },
                }}
            >
                <svg width="50px" height="40px" viewBox="0 0 100 100">
                    {/* 원 */}
                    <circle cy="50" cx="40" r="50" stroke={colorMode} strokeWidth="2" fill="none" />
                    {/* 화살표 선 */}
                    <line className="arrow-line" x1="30" y1="50" x2="130" y2="50" stroke={colorMode} strokeWidth="2" />
                    {/* 화살표 머리 */}
                    <polyline
                        className="arrow-head"
                        points="30,40 20,50 30,60"
                        fill="none"
                        stroke={colorMode}
                        strokeWidth="2"
                    />
                </svg>
            </Center>

            {/* 현재 페이지 */}
            {showPage && (
                <Center
                    w="88px"
                    h="34px"
                    gap="8px"
                    sx={{
                        "& p": {
                            color: colorMode,
                        },
                    }}
                >
                    <Text {...FONT("pretendard", 24, 600, 1.4)}>{currentPage + 1}</Text>
                    <Text {...FONT("pretendard", 16, 400, 1.4)}>/</Text>
                    <Text {...FONT("pretendard", 16, 400, 1.4)}>{totalPages}</Text>
                </Center>
            )}

            {/* 다음 버튼 */}
            <Box
                onClick={nextPage}
                role="button"
                sx={{
                    "& svg .arrow-line, & svg .arrow-head": {
                        transition: "transform 0.3s ease",
                        transform: "translateX(0)",
                    },
                    "&:hover svg .arrow-line, &:hover svg .arrow-head": {
                        transform: "translateX(10px)",
                    },
                }}
            >
                <svg width="50px" height="40px" viewBox="0 0 100 100">
                    {/* 원 */}
                    <circle cx="60" cy="50" r="50" stroke={colorMode} strokeWidth="2" fill="none" />
                    {/* 화살표 선 */}
                    <line className="arrow-line" x1="-30" y1="50" x2="70" y2="50" stroke={colorMode} strokeWidth="2" />
                    {/* 화살표 머리 */}
                    <polyline
                        className="arrow-head"
                        points="70,40 80,50 70,60"
                        fill="none"
                        stroke={colorMode}
                        strokeWidth="2"
                    />
                </svg>
            </Box>
        </Center>
    );
};
